import { NextSeo } from 'next-seo';
import Link from 'next/link';

export default function PrivacyPage() {
  return (
    <div>
      <NextSeo title={'Privacy Policy'} />
      <section className="px-6 md:px-8 mt-12 space-y-6 mb-12">
        <h4 className="text-3xl">Privacy Policy for Degaan</h4>
        <div>
          <p>
            This privacy policy sets out how Degaan uses and protects any
            information that you give Degaan when you use this website. Degaan
            is committed to ensuring that your privacy is protected. Should we
            ask you to provide certain information by which you can be
            identified when using this website, then you can be assured that it
            will only be used in accordance with this privacy statement. Degaan
            may change this policy from time to time by updating this page. You
            should check this page from time to time to ensure that you are
            happy with any changes. This policy is effective from 11/23/2021
          </p>
          <h6 className="mt-4 mb-4">
            <strong>GDPR Compliance:</strong>
          </h6>
          <p>
            This Site is intended solely for individuals residing outside of the
            territory of the European Union. By accessing and using this Site,
            you hereby agree and represent either (i) you are not a resident of
            the European Union, or (ii) if you are a resident of the European
            Union, that you hereby provide express consent to any personal
            information which may be collected from you by this Site, including,
            but not limited to, first name, last name, email address, phone
            number, physical address, IP address, and social media accounts and
            information. In no event shall any user cause this Site to collect
            personal information of any individual residing in the European
            Union without first obtaining the express consent of such
            individual.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Terms &amp; Conditions:</strong>
          </h6>
          <p>
            By accessing this website, you are agreeing to the{' '}
            <Link href="/tos" prefetch={false}>
              <a>terms of use</a>
            </Link>
            .
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Consent to be Contacted:</strong>
          </h6>
          <p>
            (CASL) If you wish to register on this website you are giving
            expressed consent for us to email, call and text message you. If you
            do not wish for this type of communication please do not register.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>What we collect:</strong>
          </h6>
          <p>
            We collect all information from our sign up process. This
            information is disclosed during the sign up process and can include,
            name, email, city, province, gender, birthday, picture, website and
            IP location. <br />
          </p>
          <h6 className="mt-4 mb-4">
            <strong>What we do with the information:</strong>
          </h6>
          <p>
            We use this information to pass along to an agent to help you find a
            property. You will be contacted by email, text or phone using this
            information.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Internal record keeping:</strong>
          </h6>
          <p>
            We may use the information to improve our products and services. We
            may periodically send promotional email about new products, special
            offers or other information which we think you may find interesting
            using the email address which you have provided. From time to time,
            we may also use your information to contact you for market research
            purposes. We may contact you by email, phone, fax or mail. We may
            use the information to customize the website according to your
            interests. We may provide your information to our third party
            partners for marketing or promotional purposes. We will never sell
            your information.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Security:</strong>
          </h6>
          <p>
            We are committed to ensuring that your information is secure. In
            order to prevent unauthorized access or disclosure we have put in
            place suitable physical, electronic and managerial procedures to
            safeguard and secure the information we collect online.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>How we use cookies:</strong>
          </h6>
          <p>
            A cookie is a small file which asks permission to be placed on your
            computer&apos;s hard drive. Once you agree, the file is added and
            the cookie helps analyze web traffic or lets you know when you visit
            a particular site. Cookies allow web applications to respond to you
            as an individual. The web application can tailor its operations to
            your needs, likes and dislikes by gathering and remembering
            information about your preferences. We use traffic log cookies to
            identify which pages are being used. This helps us analyze data
            about web page traffic and improve our website in order to tailor it
            to customer needs. We only use this information for statistical
            analysis purposes and then the data is removed from the system.
            Overall, cookies help us provide you with a better website, by
            enabling us to monitor which pages you find useful and which you do
            not. A cookie in no way gives us access to your computer or any
            information about you, other than the data you choose to share with
            us. You can choose to accept or decline cookies. Most web browsers
            automatically accept cookies, but you can usually modify your
            browser setting to decline cookies if you prefer. This may prevent
            you from taking full advantage of the website.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Links to other websites:</strong>
          </h6>
          <p>
            Our website may contain links to enable you to visit other websites
            of interest easily. However, once you have used these links to leave
            our site, you should note that we do not have any control over that
            other website. Therefore, we cannot be responsible for the
            protection and privacy of any information which you provide whilst
            visiting such sites and such sites are not governed by this privacy
            statement. You should exercise caution and look at the privacy
            statement applicable to the website in question.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Controlling your personal information:</strong>
          </h6>
          <p>
            If you wish to opt out of contact you can click on the unsubscribe
            link on the bottom of any email correspondence. If you wish to opt
            out of phone calls please email{' '}
            <a href="mailto:support@insiderealestate.com">
              support@insiderealestate.com
            </a>
            .
          </p>
          <h6 className="mt-4 mb-4">
            <strong>California Consumer Privacy Policy Compliance:</strong>
          </h6>
          <p>
            We adopt this section to comply with the California Consumer Privacy
            Act of 2018 (CCPA) and any terms defined in the CCPA have the same
            meaning when used in this section.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Collection of Personal Information:</strong>
          </h6>
          <p>
            We collect information that identifies, relates to, describes,
            references, is reasonably capable of being associated with, or could
            reasonably be linked, directly or indirectly, with a particular
            consumer, household, or device (“personal information”). However,
            personal information does not include publicly available information
            from government records or deidentified or aggregated consumer
            information.
          </p>
          <p className="mt-4">
            In particular, within the last twelve months we have collected the
            following categories of personal information: (a) identifiers; (b)
            personal information categories listed in the California Customer
            Records statute; (c) commercial information; (d) internet or other
            similar network activity; and (e) inferences drawn from other
            personal information. We gather these categories of personal
            information directly from you when you register to use our services
            and indirectly from you as you interact with our website. However,
            please note, that you may visit our website anonymously.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Use of Personal Information:</strong>
          </h6>
          <p>
            We may use or disclose the personal information we collect for one
            or more of the following purposes:
          </p>
          <ol className="mt-4 mb-4 pl-10" style={{ listStyle: 'auto' }}>
            <li>
              To fulfill or meet the reason you provided the information. For
              example, if you share you name and contact information to purchase
              a product or service, we will use that information to process you
              payment and facilitate delivery.
            </li>
            <li>
              To provide support, personalize and develop our website, products
              and services.
            </li>
            <li>
              To create maintain, customize and secure your account with us.
            </li>
            <li>
              To process your requests, purchases, transactions and payments and
              prevent transactional fraud.
            </li>
            <li>
              To provide you with support and to respond to inquiries, including
              to investigate and address your concerns and monitor and improve
              response.
            </li>
            <li>
              To personalize your website experience and to deliver content and
              product and service offerings relevant to your interests,
              including targeted offers and ads through our website and
              third-party sites.
            </li>
            <li>
              For testing, research, analysis and product development, including
              to develop and improve our website, products and services.
            </li>
            <li>
              To respond to law enforcement requests and as required by
              applicable law, court order, or governmental regulations.
            </li>
            <li>
              As described to you when collecting your personal information or
              as otherwise set forth in the CCPA.
            </li>
          </ol>
          <p>
            We will not collect additional categories of personal information or
            use the personal information we collected for materially different,
            unrelated, or incompatible purposes without providing you notice.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Sharing Personal Information:</strong>
          </h6>
          <p>
            We may disclose your personal information to a third party for a
            business purpose. When we disclose personal information for a
            business purpose, we enter a contract that describes the purpose and
            requires the recipient to both keep that personal information
            confidential and not use it for any purpose except performing the
            contact. The CCPA prohibits third parties who receive your personal
            information from reselling it unless you have received explicit
            notice and an opportunity to opt-out of the sale of your personal
            information. We share your personal information only with service
            providers.
          </p>
          <p className="mt-4">
            In the preceding twelve months, we have disclosed the following
            categories of personal information for a business purpose: (a)
            identifiers; (b) California Customer records personal information
            (as described above); (c) commercial information; (d) internet or
            other similar network activity; and (e) inferences drawn from other
            personal information. The only category of third parties with whom
            we share your personal information are service providers.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Sale of personal information:</strong>
          </h6>
          <p>
            In the preceding twelve months, we have not sold personal
            information.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Your Rights and Choices:</strong>
          </h6>
          <p>
            The CCPA provides consumers who are California residents with
            specific rights regarding their personal information. This section
            describes your CCPA rights and explains how to exercise those
            rights.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>
              Access to Specific Information and Data Portability Rights:
            </strong>
          </h6>
          <p>
            You have the right to request that we disclose certain information
            to you about our collection and use of your personal information
            over the past twelve months. Once we receive and confirm your
            verifiable consumer request, we will disclose to you: (a) the
            categories of personal information we collected about you; (b) the
            categories of sources of the personal information we collected about
            you; (c) our business or commercial purpose for collected or
            disclosing your personal information; (d) the categories of third
            parties with whom we share your personal information; (e) the
            specific pieces of personal information we collected about you (this
            is also called a data portability request); (f) if we disclosed your
            personal information for a business purpose we will provide the
            personal information categories that each recipient received.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Deletion Request Rights:</strong>
          </h6>
          <p>
            You have the right to request that we delete any of your personal
            information that we collected from you and retained, subject to
            certain exceptions. Once we have received and confirm your
            verifiable request, we will delete, and direct our service providers
            to delete, your personal information from our records, unless an
            exception applies.
          </p>
          <p className="mt-4">
            We may deny your request if retaining the information is necessary
            for us or our service providers to: (1) complete the transaction for
            which we collected the personal information, provide a good or
            service that you requested, take actions reasonably anticipated
            within the context of our ongoing business relationship with you,
            fulfill the terms of the written warranty or product recall
            conducted in accordance with federal law, or otherwise perform our
            contract with you; (2) detect security incidents, protect against
            malicious, deceptive, fraudulent, or illegal activity, or prosecute
            those responsible for such activities; (3) debug products to
            identify and repair errors that impair existing intended
            functionality; (4) exercise free speech, ensure the right of another
            consumer to exercise their free speech rights, or exercise another
            right provided for by law; (5) comply with the California Electronic
            Communications Privacy Act (Cal. Penal Code § 1546 et. seq.); (6)
            Engage in public or peer-reviewed scientific, historical or
            statistical research in the public interest that adheres to all
            other applicable ethics and privacy laws, when the information’s
            deletion may likely render impossible or seriously impair the
            research’s achievement, if you previously provided informed consent;
            (7) enable solely internal uses that are reasonably aligned with
            consumer expectations based on your relationship with us; (8) comply
            with a legal obligation; or (9) make other internal and lawful uses
            of that information that are compatible with the context in which
            you provided it.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>
              Exercising Access, Data Portability and Deletion Rights:
            </strong>
          </h6>
          <p>
            Only you, or someone legally authorized to act on your behalf, may
            make a verifiable consumer request related to your personal
            information. You may also make a verifiable consumer request on
            behalf of your minor child. To designate an authorized realtor,
            please submit a proof of authorization with the verifiable request.
          </p>
          <p className="mt-4">
            You may only make a verifiable consumer request for access or data
            portability twice within a 12-month period. The verifiable consumer
            request must provide sufficient information that allows us to
            reasonably verify you are the person about whom we collected
            personal information or an authorized representative and describe
            your request with sufficient detail that allows us to properly
            understand, evaluate and respond to it. We cannot respond to your
            request or provide you with personal information if we cannot verify
            your identity or the authority to make the request and confirm the
            personal information relates to you. We will only use any personal
            information provided in a verifiable consumer request to verify the
            requestor’s identity or authority to make the request. Making a
            verifiable request does not require you to create an account with
            us. We will never provide your social security number, credit card
            numbers or any other sensitive personal information pursuant to a
            request under the CCPA, rather we will treat any such requests as
            requests to delete.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Response Timing and Format:</strong>
          </h6>
          <p>
            We use our best efforts to respond to verifiable consumer requests
            within forty-five days of its receipt. If we require more time, up
            to ninety days, we will inform you of the reason and the extension
            period in writing. We will deliver our written response by mail or
            electronically, at your option.
          </p>
          <p className="mt-4">
            Any disclosure we provide will only cover the twelve-month period
            preceding the receipt of a verifiable consumer request. The response
            we provide will also explain the reasons we cannot comply with a
            request, if applicable. For data portability requests, we will
            select a format to provide your personal information that is readily
            useable and should allow you to transmit the information from one
            entity to another without hinderance, specifically in a portable
            document format sent through your account or the e-mail address
            provided.
          </p>
          <p className="mt-4">
            We do not charge a fee to process or respond to your verifiable
            consumer request unless it is excessive, repetitive or manifestly
            unfounded. If we determine that the request warrants a fee, we will
            tell you why we made that decision and provide you with a cost
            estimate before completing your request.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>
              Personal Information Sales Opt-Out and Opt-In Rights:
            </strong>
          </h6>
          <p>
            We do not sell your personal information. If at any time we decide
            to sell your personal information, we will provide notice
            beforehand, pursuant to the CCPA, and provide instructions for you
            to opt out of the sale of personal information.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Non-Discrimination:</strong>
          </h6>
          <p>
            We will not discriminate against you for exercising any of your
            rights under the CCPA. Specifically, unless permitted by the CCPA,
            we will not: (a) deny you goods or services; (b) charge you
            different prices or rates for goods or services, including through
            granting discounts or other benefits, or imposing penalties; (c)
            provide you a different level or quality of goods or services; or
            (d) suggest that you may receive a different price or rate for goods
            or services or a different level or quality of goods or services.
            However, we may offer you certain financial incentives permitted by
            the CCPA that can result in different prices, rates or quality
            levels. Any CCPA-permitted financial incentive we offer will
            reasonably relate to the value of your personal information and
            contain written terms that describe the program’s material aspects.
            Participation in a financial incentive program requires you to
            opt-in, which may be revoked at any time.
          </p>
        </div>
      </section>
    </div>
  );
}
